/** @jsxImportSource @emotion/react */
import React from "react";
import { StyledText } from "../assets/typography/typography";
import { css } from "@emotion/react";

interface IconWrappedRoundedProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  backgroundColor: string;
  color?: string;
  width?: string;
  height?: string;
  iconSize?: "large" | "small";
}

const textStyle = css`
  display: flex;
`;

export const IconWrapperRounded = ({
  children,
  backgroundColor,
  color,
  width,
  height,
  iconSize = "small",
  ...rest
}: IconWrappedRoundedProps) => {
  const wrapperStyle = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    width: ${width || "24px"};
    min-width: ${width || "24px"};
    min-height: ${height || "24px"};
    height: ${height || "24px"};
    background-color: ${backgroundColor};
  `;

  return (
    <div css={wrapperStyle} {...rest}>
      {iconSize === "small" ? (
        <StyledText
          css={textStyle}
          color={color}
          className="bodySubtextRegular mb-0"
        >
          {children}
        </StyledText>
      ) : (
        <StyledText
          css={textStyle}
          color={color}
          className="bodyTextSemibold mb-0"
        >
          {children}
        </StyledText>
      )}
    </div>
  );
};
